import DenseButton from './DenseButton';

export * from './DenseButtonProps';
export default DenseButton;
